import { useColorModeValue } from '@chakra-ui/react';

export const useBinderCardColors = () => {
  return {
    borderColor: useColorModeValue('gray.200', 'whiteAlpha.200'),
    bgColor: useColorModeValue('white', 'navy.800'),
    textColor: useColorModeValue('gray.700', 'white'),
    failedTextColor: useColorModeValue('red.600', 'red.300'),
    labelColor: useColorModeValue('gray.600', 'gray.400'),
    valueColor: useColorModeValue('gray.800', 'white'),
    descriptionColor: useColorModeValue('gray.500', 'gray.400'),
    emptyFieldBgColor: useColorModeValue('gray.50', 'gray.700'),
    iconBgColor: useColorModeValue('gray.100', 'gray.700'),
    passedBgColor: useColorModeValue('green.50', 'green.900'),
    cautionBgColor: useColorModeValue('orange.50', 'orange.900'),
    failedBgColor: useColorModeValue('red.50', 'red.900'),
    tableHeaderBg: useColorModeValue('gray.50', 'gray.700'),
  };
};
